import React from "react"; 
export class CasinoMaratonInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() { 
        return (
            <div className="casino-maraton-section">
                <h2>Zaigraj Brzinski SuperSkok vrijedan 50.000 eura! 🏆</h2>
                <p>Pobjeda je slatka, kad utrka je kratka.</p>
                <p>Uključi se u <strong>dvije fantastične utrke</strong> koje traju od <strong>4. do 7.3.</strong> i na brzinu pokupi super nagrade iz ukupnog fonda od <strong>50.000 eura!</strong></p>
                <br></br>
                <p className="text"><b>Sprint </b></p>
                <span className="img-character"></span>
                <p>👉 <strong>Svaki dan</strong> odigraj <strong>minimalno 100</strong> € kroz <strong>ODABRANE igre</strong></p>
                <p>👉 Odigraj do kraja i <strong>podijeli 40.000 €</strong> s ostalim igračima koji završe utrku, a tijekom Sprinta možeš se <strong>kvalificirati i za SuperSkok</strong>. 👇</p>
                <br></br>
                <p className="text"><b>SuperSkok</b></p>
                <p>👉 Vrtnje od minimalno 0,30 € kvalificiraju te za ovu utrku</p>
                <p>💯 Skupljaj bodove na temelju <strong>maksimalnog dnevnog multiplikatora*</strong></p>
                <p>🏆 Na kraju utrke <strong>TOP 30 igrača</strong> prema bodovnoj rang-ljestvici dijeli <strong>dodatnih 10.000 €.</strong></p>
                <br></br>
                <p>**Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</p>
                <div className="divider"></div>     
            </div>
        );
    }
}